import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/ua/blog/',
    component: ComponentCreator('/ua/blog/', 'e20'),
    exact: true
  },
  {
    path: '/ua/blog/archive/',
    component: ComponentCreator('/ua/blog/archive/', '1bc'),
    exact: true
  },
  {
    path: '/ua/blog/authors/',
    component: ComponentCreator('/ua/blog/authors/', '82d'),
    exact: true
  },
  {
    path: '/ua/blog/event-sourcing-blockchain-reorgs/',
    component: ComponentCreator('/ua/blog/event-sourcing-blockchain-reorgs/', '2bc'),
    exact: true
  },
  {
    path: '/ua/blog/how-cqrs-and-eventsourcing-work/',
    component: ComponentCreator('/ua/blog/how-cqrs-and-eventsourcing-work/', '9e3'),
    exact: true
  },
  {
    path: '/ua/blog/index-ethereum-events-without-the-graph/',
    component: ComponentCreator('/ua/blog/index-ethereum-events-without-the-graph/', 'c8b'),
    exact: true
  },
  {
    path: '/ua/blog/introducing-evm-crawler/',
    component: ComponentCreator('/ua/blog/introducing-evm-crawler/', 'f3a'),
    exact: true
  },
  {
    path: '/ua/blog/nestjs-application-launch-modes/',
    component: ComponentCreator('/ua/blog/nestjs-application-launch-modes/', '504'),
    exact: true
  },
  {
    path: '/ua/blog/self-hosted-vs-cloud-blockchain-indexers/',
    component: ComponentCreator('/ua/blog/self-hosted-vs-cloud-blockchain-indexers/', 'a9a'),
    exact: true
  },
  {
    path: '/ua/blog/tags/',
    component: ComponentCreator('/ua/blog/tags/', 'd75'),
    exact: true
  },
  {
    path: '/ua/blog/tags/announcement/',
    component: ComponentCreator('/ua/blog/tags/announcement/', '02c'),
    exact: true
  },
  {
    path: '/ua/blog/tags/architecture/',
    component: ComponentCreator('/ua/blog/tags/architecture/', 'b40'),
    exact: true
  },
  {
    path: '/ua/blog/tags/backend/',
    component: ComponentCreator('/ua/blog/tags/backend/', '038'),
    exact: true
  },
  {
    path: '/ua/blog/tags/balances/',
    component: ComponentCreator('/ua/blog/tags/balances/', '9be'),
    exact: true
  },
  {
    path: '/ua/blog/tags/bitcoin/',
    component: ComponentCreator('/ua/blog/tags/bitcoin/', 'b0a'),
    exact: true
  },
  {
    path: '/ua/blog/tags/blockchain/',
    component: ComponentCreator('/ua/blog/tags/blockchain/', 'cbc'),
    exact: true
  },
  {
    path: '/ua/blog/tags/comparison/',
    component: ComponentCreator('/ua/blog/tags/comparison/', '36e'),
    exact: true
  },
  {
    path: '/ua/blog/tags/context/',
    component: ComponentCreator('/ua/blog/tags/context/', '9a0'),
    exact: true
  },
  {
    path: '/ua/blog/tags/cost/',
    component: ComponentCreator('/ua/blog/tags/cost/', '9fe'),
    exact: true
  },
  {
    path: '/ua/blog/tags/cqrs/',
    component: ComponentCreator('/ua/blog/tags/cqrs/', '9a1'),
    exact: true
  },
  {
    path: '/ua/blog/tags/design-patterns/',
    component: ComponentCreator('/ua/blog/tags/design-patterns/', 'daf'),
    exact: true
  },
  {
    path: '/ua/blog/tags/development/',
    component: ComponentCreator('/ua/blog/tags/development/', '873'),
    exact: true
  },
  {
    path: '/ua/blog/tags/easylayer/',
    component: ComponentCreator('/ua/blog/tags/easylayer/', '4e6'),
    exact: true
  },
  {
    path: '/ua/blog/tags/erc-20/',
    component: ComponentCreator('/ua/blog/tags/erc-20/', 'b6a'),
    exact: true
  },
  {
    path: '/ua/blog/tags/ethereum/',
    component: ComponentCreator('/ua/blog/tags/ethereum/', 'd46'),
    exact: true
  },
  {
    path: '/ua/blog/tags/event-sourcing/',
    component: ComponentCreator('/ua/blog/tags/event-sourcing/', 'aea'),
    exact: true
  },
  {
    path: '/ua/blog/tags/evm/',
    component: ComponentCreator('/ua/blog/tags/evm/', 'b48'),
    exact: true
  },
  {
    path: '/ua/blog/tags/http/',
    component: ComponentCreator('/ua/blog/tags/http/', 'f3d'),
    exact: true
  },
  {
    path: '/ua/blog/tags/indexer/',
    component: ComponentCreator('/ua/blog/tags/indexer/', '358'),
    exact: true
  },
  {
    path: '/ua/blog/tags/infrastructure/',
    component: ComponentCreator('/ua/blog/tags/infrastructure/', '341'),
    exact: true
  },
  {
    path: '/ua/blog/tags/launch-modes/',
    component: ComponentCreator('/ua/blog/tags/launch-modes/', 'ab3'),
    exact: true
  },
  {
    path: '/ua/blog/tags/microservices/',
    component: ComponentCreator('/ua/blog/tags/microservices/', '788'),
    exact: true
  },
  {
    path: '/ua/blog/tags/nestjs-cqrs/',
    component: ComponentCreator('/ua/blog/tags/nestjs-cqrs/', '170'),
    exact: true
  },
  {
    path: '/ua/blog/tags/nestjs/',
    component: ComponentCreator('/ua/blog/tags/nestjs/', '155'),
    exact: true
  },
  {
    path: '/ua/blog/tags/nodejs/',
    component: ComponentCreator('/ua/blog/tags/nodejs/', '593'),
    exact: true
  },
  {
    path: '/ua/blog/tags/open-source/',
    component: ComponentCreator('/ua/blog/tags/open-source/', '58d'),
    exact: true
  },
  {
    path: '/ua/blog/tags/reorg/',
    component: ComponentCreator('/ua/blog/tags/reorg/', 'c15'),
    exact: true
  },
  {
    path: '/ua/blog/tags/reorganization/',
    component: ComponentCreator('/ua/blog/tags/reorganization/', '61a'),
    exact: true
  },
  {
    path: '/ua/blog/tags/self-hosted/',
    component: ComponentCreator('/ua/blog/tags/self-hosted/', 'f6c'),
    exact: true
  },
  {
    path: '/ua/blog/tags/smart-contracts/',
    component: ComponentCreator('/ua/blog/tags/smart-contracts/', 'd39'),
    exact: true
  },
  {
    path: '/ua/blog/tags/sqd/',
    component: ComponentCreator('/ua/blog/tags/sqd/', '6dd'),
    exact: true
  },
  {
    path: '/ua/blog/tags/tcp/',
    component: ComponentCreator('/ua/blog/tags/tcp/', '9eb'),
    exact: true
  },
  {
    path: '/ua/blog/tags/the-graph/',
    component: ComponentCreator('/ua/blog/tags/the-graph/', 'f9c'),
    exact: true
  },
  {
    path: '/ua/blog/tags/transactional/',
    component: ComponentCreator('/ua/blog/tags/transactional/', '355'),
    exact: true
  },
  {
    path: '/ua/blog/tags/typescript/',
    component: ComponentCreator('/ua/blog/tags/typescript/', '55e'),
    exact: true
  },
  {
    path: '/ua/blog/tags/utxo/',
    component: ComponentCreator('/ua/blog/tags/utxo/', '799'),
    exact: true
  },
  {
    path: '/ua/blog/tags/wallet/',
    component: ComponentCreator('/ua/blog/tags/wallet/', 'f87'),
    exact: true
  },
  {
    path: '/ua/blog/tags/websocket/',
    component: ComponentCreator('/ua/blog/tags/websocket/', 'e9b'),
    exact: true
  },
  {
    path: '/ua/blog/tags/welcome/',
    component: ComponentCreator('/ua/blog/tags/welcome/', '3ba'),
    exact: true
  },
  {
    path: '/ua/blog/track-bitcoin-wallet-balances/',
    component: ComponentCreator('/ua/blog/track-bitcoin-wallet-balances/', 'd6d'),
    exact: true
  },
  {
    path: '/ua/blog/welcome-bitcoin-crawler-beta-app/',
    component: ComponentCreator('/ua/blog/welcome-bitcoin-crawler-beta-app/', '67b'),
    exact: true
  },
  {
    path: '/ua/blog/welcome-from-easylayer-team/',
    component: ComponentCreator('/ua/blog/welcome-from-easylayer-team/', 'd09'),
    exact: true
  },
  {
    path: '/ua/enterprise/',
    component: ComponentCreator('/ua/enterprise/', 'f8a'),
    exact: true
  },
  {
    path: '/ua/licenses/',
    component: ComponentCreator('/ua/licenses/', 'a5e'),
    exact: true
  },
  {
    path: '/ua/policy/',
    component: ComponentCreator('/ua/policy/', '692'),
    exact: true
  },
  {
    path: '/ua/proof/',
    component: ComponentCreator('/ua/proof/', 'abf'),
    exact: true
  },
  {
    path: '/ua/security/',
    component: ComponentCreator('/ua/security/', 'f6f'),
    exact: true
  },
  {
    path: '/ua/terms/',
    component: ComponentCreator('/ua/terms/', 'd4f'),
    exact: true
  },
  {
    path: '/ua/why/',
    component: ComponentCreator('/ua/why/', 'ed4'),
    exact: true
  },
  {
    path: '/ua/docs/',
    component: ComponentCreator('/ua/docs/', '6f1'),
    routes: [
      {
        path: '/ua/docs/',
        component: ComponentCreator('/ua/docs/', 'cae'),
        routes: [
          {
            path: '/ua/docs/',
            component: ComponentCreator('/ua/docs/', '962'),
            routes: [
              {
                path: '/ua/docs/',
                component: ComponentCreator('/ua/docs/', 'cd0'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/data-modeling/',
                component: ComponentCreator('/ua/docs/data-modeling/', '4c7'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/event-store/',
                component: ComponentCreator('/ua/docs/event-store/', 'db4'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/examples/',
                component: ComponentCreator('/ua/docs/examples/', 'f2c'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/first-custom-model/',
                component: ComponentCreator('/ua/docs/first-custom-model/', '363'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/',
                component: ComponentCreator('/ua/docs/get-started/', '764'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/', '3b4'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/0.0.2/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/0.0.2/', '841'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.0.10-alpha.0/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.0.10-alpha.0/', '9a7'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.0.10/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.0.10/', '579'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.0.4/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.0.4/', '068'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.0.5/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.0.5/', 'ea5'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.0.6/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.0.6/', 'a21'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.0.7/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.0.7/', '793'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.0.8/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.0.8/', '4c7'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.0.9/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.0.9/', 'a88'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.1.0/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.1.0/', '31c'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.1.1-alpha.0/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.1.1-alpha.0/', '7a4'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.1.1/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.1.1/', '783'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.1.2-alpha.0/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.1.2-alpha.0/', '392'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.1.2/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.1.2/', 'c1a'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.1.3/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.1.3/', '9dc'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.2.0/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.2.0/', '9d2'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.2.1/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.2.1/', 'eb4'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.3.0/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.3.0/', '686'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.3.1/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.3.1/', '12e'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/bitcoin-crawler/v0.4.0/',
                component: ComponentCreator('/ua/docs/get-started/bitcoin-crawler/v0.4.0/', '423'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/evm-crawler/',
                component: ComponentCreator('/ua/docs/get-started/evm-crawler/', 'cb1'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/evm-crawler/v0.0.2/',
                component: ComponentCreator('/ua/docs/get-started/evm-crawler/v0.0.2/', 'ec8'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/evm-crawler/v0.0.3-alpha.0/',
                component: ComponentCreator('/ua/docs/get-started/evm-crawler/v0.0.3-alpha.0/', '768'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/evm-crawler/v0.0.3/',
                component: ComponentCreator('/ua/docs/get-started/evm-crawler/v0.0.3/', '9f5'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/evm-crawler/v0.1.0/',
                component: ComponentCreator('/ua/docs/get-started/evm-crawler/v0.1.0/', '61b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/transport-sdk/',
                component: ComponentCreator('/ua/docs/get-started/transport-sdk/', 'cc5'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/transport-sdk/v1.0.14/',
                component: ComponentCreator('/ua/docs/get-started/transport-sdk/v1.0.14/', 'cc1'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/transport-sdk/v1.0.15/',
                component: ComponentCreator('/ua/docs/get-started/transport-sdk/v1.0.15/', '694'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/transport-sdk/v1.0.16/',
                component: ComponentCreator('/ua/docs/get-started/transport-sdk/v1.0.16/', '689'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/transport-sdk/v1.1.0/',
                component: ComponentCreator('/ua/docs/get-started/transport-sdk/v1.1.0/', '22b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/transport-sdk/v1.1.1/',
                component: ComponentCreator('/ua/docs/get-started/transport-sdk/v1.1.1/', '744'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/transport-sdk/v1.2.0/',
                component: ComponentCreator('/ua/docs/get-started/transport-sdk/v1.2.0/', '388'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/get-started/transport-sdk/v1.3.0/',
                component: ComponentCreator('/ua/docs/get-started/transport-sdk/v1.3.0/', '28b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/mempool-monitoring/',
                component: ComponentCreator('/ua/docs/mempool-monitoring/', '49e'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/network-providers/',
                component: ComponentCreator('/ua/docs/network-providers/', 'bb5'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/overview/',
                component: ComponentCreator('/ua/docs/overview/', '80f'),
                exact: true
              },
              {
                path: '/ua/docs/quickstart/',
                component: ComponentCreator('/ua/docs/quickstart/', '820'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/system-models/',
                component: ComponentCreator('/ua/docs/system-models/', '140'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/transport-layer/',
                component: ComponentCreator('/ua/docs/transport-layer/', 'a8e'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/vs-alternatives/',
                component: ComponentCreator('/ua/docs/vs-alternatives/', '98c'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/when-to-use/',
                component: ComponentCreator('/ua/docs/when-to-use/', '35f'),
                exact: true,
                sidebar: "docs"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/ua/',
    component: ComponentCreator('/ua/', 'ae9'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
